import RaceChooseConfirm from './RaceChooseConfirm';

export default RaceChooseConfirm;
export { RaceChooseConfirm };
